/* @flow */
import { promiseRelationship } from 'chat/utils/ChatPromises';
import Button from 'components/Button.jsx';
import Glyph from 'components/Glyph.jsx';
import LayerTrigger from 'components/LayerTrigger.jsx';
import React from 'react';
import RelatedUserSummary from 'entities/RelatedUserSummary';
import Relationship from 'entities/Relationship';
import Tooltip from 'components/Tooltip.jsx';

type Props = {
  user: RelatedUserSummary,
}

export default class ConversationStarter extends React.Component {
  props: Props;

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  render() {
    const { user } = this.props;
    const newConversationPath = '/classes/r/messages/new';

    const tooltip = (
      <Tooltip>
        Message attendee
      </Tooltip>
    );

    return (
      <div className="ConversationStarter">
        <Button
          onClick={() => {
            promiseRelationship(user).then((relationship: Relationship) => {
              this.context.router.push({
                pathname: `${newConversationPath}/${relationship.id}`,
              });
            });
          }}
          level="icon">
          <LayerTrigger placement="bottom" layer={tooltip}>
            <Glyph name="chat-add-bubble" color="brand" size="large" solo />
          </LayerTrigger>
        </Button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/payments/components/ConversationStarter.jsx